import React from 'react';
import { MenuItem } from 'material-ui/Menu';
import { NavLink } from 'react-router-dom';
import classes from './Menu.css';

const MenuNavItem = ({ to, onClick, label }) => {
    return (
        <MenuItem className={classes.menuListItem}>
            <NavLink className={classes.menuItem} onClick={onClick} to={to}>
                {label}
            </NavLink>
        </MenuItem>
    );
};

export default MenuNavItem;
